export const environment = {
  production: false,
  serverUrl: 'https://keeplaying-server.azurewebsites.net/',
  // serverUrl: 'http://localhost:3300/'
};
